import styled, { keyframes } from "styled-components";
import LandingPage from "./LandingPage";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SubpageLayout from "./subpages/SubpageLayout";
import ThreeD from "./subpages/ThreeD";
import Tutor from "./subpages/Tutor";
import BioViz from "./subpages/BioViz";


const FadeOutKeyframes = keyframes`
  from {
    opacity: 1;
    filter: blur(0px);
  }
  to {
    opacity: 0;
    filter: blur(100px);
  }
`

const FadeInKeyframes = keyframes`
  from {
    opacity: 0;
    filter: blur(100px);

  }
  to {
    opacity: 1;
    filter: blur(0px);

  }
`

const FadingDiv = styled.div<{ animationState: string }>`
  opacity: ${props => props.animationState == 'fadeIn' ? 1 : 0};
  animation: ${props => props.animationState == 'fadeIn' ? FadeInKeyframes : FadeOutKeyframes} 0.25s ease-in-out;
`

function App() {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransistionStage] = useState("fadeIn");

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setTransistionStage("fadeOut");
    }
  }, [location.pathname]);

  return (
    <FadingDiv
      animationState={transitionStage}
      onAnimationEnd={() => {
        if (transitionStage === "fadeOut") {
          setDisplayLocation(location);
          setTransistionStage("fadeIn");
        }
      }}
    >
      <Routes location={displayLocation}>
        <Route path="/" element={<LandingPage></LandingPage>} />
        <Route path="/digital-3d-artist" element={<SubpageLayout><ThreeD /></SubpageLayout>} />
        <Route path="/programming-tutor" element={<SubpageLayout><Tutor /></SubpageLayout>} />
        <Route path="/bioviz-researcher" element={<SubpageLayout><BioViz /></SubpageLayout>} />
      </Routes>
    </FadingDiv>
  );
}

export default App;
